import React from 'react';
import { withRouter, Route, Switch } from 'react-router-dom'
import { WhoCanHelpGameData } from './../../data/GameData';
import Header from '../Header';
import ScenarioPicker from './ScenarioPicker';
import PersonPicker from './PersonPicker';
import ModalMenu from './ModalMenu';
import Summary from './Summary';

import { motion, AnimatePresence } from "framer-motion";
import { fadeInTransition } from './../../data/Transitions';

class WhoCanHelp extends React.Component {
  
  constructor(props) {
    super(props)
    this.state = {
      isShowingModal: false,
      scenarios: WhoCanHelpGameData.scenarios,
      selectedScenario: null,
      isChangingRoutes: false,
      printing: false
    };
    
  }
  
  componentDidMount() {

  }
  
  didSelectBrandLogo = () => {
    var self = this;
    self.setState({isChangingRoutes: true})
     
    setTimeout(function() {
      self.setState({isChangingRoutes: false})
      self.props.history.push('/')
    }, 500);
  }
  
  didSelectBack = () => {
    var self = this;
    self.setState({isChangingRoutes: true})
     
    setTimeout(function() {
      self.setState({isChangingRoutes: false})
      //self.props.history.goBack();
      self.props.history.push('/who-can-help')
    }, 1000);
  }
  
  didSelectMenu = () => {
    var self = this;
    self.setState({isShowingModal: true})
  }
  
  didSelectCloseMenu = () => {
    var self = this;
    self.setState({isShowingModal: false})
  }
  
  didSelectFinish = () => {
    var self = this;
    self.setState({isChangingRoutes: true, isShowingModal: false})
     
    setTimeout(function() {
      self.setState({isChangingRoutes: false})
      self.props.history.push('/who-can-help/summary')
    }, 1000);
  }
  
  didSelectScenario = (scenario) => {
    var self = this;
    self.setState({selectedScenario: scenario, isChangingRoutes: true, isShowingModal: false})
     
    setTimeout(function() {
      self.setState({isChangingRoutes: false});
      self.props.history.push('/who-can-help/'+scenario.slug);
    }, 1000);
    
  }

  didSelectPrint = () => {
    // @todo print screen...
    //prompt("Permalink", this.permalink());
    this.setState({printing:true});
    fetch('https://o18jzj3fw8.execute-api.ap-southeast-2.amazonaws.com/Prod/snap', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        path: this.permalink(),//'http://games.playingitsafe.org.au/share-that-photo?people=3%2C5%2C7%2C8',
        pdf: true,
        scale: "0.6"
      }),
    }).then((response) => response.json())
    .then((responseJson) => {
      this.setState({printing:false});
      console.log(responseJson);
      if(responseJson.url){
        //window.location.href = responseJson.url;
        const win = window.open(responseJson.url, '_blank');
        if (win != null) {
          win.focus();
        }
      }
    })
    .catch((error) => {
      this.setState({printing:false});
      console.error(error);
    });;
  }

  permalink() {
    return document.location.href+'?action=print';
  }
  
  render() {
    
    const { isChangingRoutes, scenarios, isShowingModal, printing } = this.state;

    var self = this,
        path = this.props.location.pathname.split("/").pop(),
        mainClasses = ['main--'+path];
        
        if(!path.length) {
          mainClasses.push('main--who-can-help-home');
        }
        
        if(isShowingModal) {
          mainClasses.push('main--inactive');
        }

    return (
      
      <div>
          
          <Header onSelectBack={self.didSelectBack} onSelectFinish={self.didSelectFinish} onSelectMenu={self.didSelectMenu} onSelectBrandLogo={self.didSelectBrandLogo} />
  
          <motion.main id="main" className={mainClasses.join(' ')} initial="unmounted" animate={(isChangingRoutes) ? 'unmounted' : 'mounted'} variants={fadeInTransition}>
  
            <Switch>
              
              <Route 
                exact 
                path="/who-can-help" 
                render={() => (
                  <ScenarioPicker onSelectScenario={self.didSelectScenario} />
                )
              } />
              
              <Route 
                path="/who-can-help/summary" 
                render={() => (
                  <Summary onPrint={self.didSelectPrint} printingStatus={printing} />
                )
              } />
              
              <Route 
                path="/who-can-help/:slug" 
                render={() => (
                  <PersonPicker onSelectMenu={self.didSelectMenu} />
                )
              } />
              
            </Switch>
            
          </motion.main>
          
          <AnimatePresence>
            {isShowingModal && (
              <ModalMenu scenarios={scenarios} onSelectClose={self.didSelectCloseMenu} onSelectFinish={self.didSelectFinish} onSelectScenario={self.didSelectScenario} />
            )}
          </AnimatePresence>

      </div>
      
    )
  }
};


export default withRouter(WhoCanHelp);
